// @flow
import * as React from 'react'
import { dateToBigDate } from '../../utils/parsingUtils'

type PropsType = {
  date: string
}

export default class BigDate extends React.Component<PropsType> {
  render () {
    const bigDate = dateToBigDate(this.props.date)
    return (
      [
        <h1 key="top">
          {bigDate.day}
          <sup>{bigDate.sup}</sup>
        </h1>,
        <h1 key="bottom">
          {bigDate.month}
        </h1>
      ]
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/Home/bigDate.jsx